export function authenticationCallbackErrorMessage(parameters: URLSearchParams): string | null {
  const errorDescription = parameters.get("error_description") ?? parameters.get("error");
  if (errorDescription === null) return null;
  const errorCode = parameters.get("error_code");
  if (errorCode === "otp_expired") return "This sign-in link has expired or was already used. Request a new email link to sign in.";
  return "Sign-in was not completed. Please try again.";
}
